import apiService from './apiService';

class VehicleService {
  async getVehicles(skip = 0, limit = 500, activeOnly = false, includeInactive = false, vehicleNumber = '') {
    try {
      let endpoint = `/api/v1/entities/vehicles/?skip=${skip}&limit=${limit}&active_only=${activeOnly}&include_inactive=${includeInactive}`;
      if (vehicleNumber) {
        endpoint += `&vehicle_number=${encodeURIComponent(vehicleNumber)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch vehicles:', error);
      throw error;
    }
  }
  
  async getAllVehicles() {
    try {
      const endpoint = '/api/v1/entities/vehicles/?active_only=false&include_inactive=true';
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch all vehicles:', error);
      throw error;
    }
  }

  async getVehicleById(id) {
    try {
      const endpoint = `/api/v1/entities/vehicles/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to fetch vehicle with ID ${id}:`, error);
      throw error;
    }
  }

  async createVehicle(vehicleData) {
    try {
      const endpoint = '/api/v1/entities/vehicles/';
      const response = await apiService.post(endpoint, vehicleData);
      return response;
    } catch (error) {
      console.error('Failed to create vehicle:', error);
      throw error;
    }
  }

  async updateVehicle(id, vehicleData) {
    try {
      const endpoint = `/api/v1/entities/vehicles/${id}`;
      const response = await apiService.put(endpoint, vehicleData);
      return response;
    } catch (error) {
      console.error(`Failed to update vehicle with ID ${id}:`, error);
      throw error;
    }
  }

  async deleteVehicle(id) {
    try {
      const endpoint = `/api/v1/entities/vehicles/${id}`;
      const response = await apiService.delete(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to delete vehicle with ID ${id}:`, error);
      throw error;
    }
  }

  async getDashboardStatistics() {
    try {
      const endpoint = '/api/v1/entities/vehicles/dashboard/statistics';
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new VehicleService();